/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
import * as React from 'react';
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';

// Quantity accepts up to 2 decimals (e.g. 7.5 hours). Matches invoice_units.quantity float(7,2).
const QuantityNumberField = React.forwardRef(function QuantityNumberField(props, ref) {
  const { name, onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      allowNegative={false}
      decimalScale={2}
      valueIsNumericString
      isAllowed={({ floatValue }) => floatValue === undefined || floatValue <= 99999.99}
      onValueChange={(values) => {
        onChange({ target: { name, value: values.value } });
      }}
    />
  );
});

QuantityNumberField.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default QuantityNumberField;
